export default __webpack_public_path__ + "static/media/grocery2.7d99faf7.jpeg";